module.exports = __webpack_public_path__ + "img/account1.d7f6f3bc.png";